import styled from 'styled-components'

export const CustomImg = styled.img`
  height: 40px;
  width: 70px;
  object-fit: cover;
  border-radius: 8px;
  object-position: center;
`
